
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Stack,
  Chip,
  Divider,
  Avatar,
} from "@mui/material";
import {
  MusicNote,
  OpenInNew,
  Quiz,
  Explore,
  AssignmentTurnedIn,
  TodayRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { trackCTA } from "../../service/usercta";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const tokens = {
  primary: "#4F46E5",
  primaryLight: "#EEF2FF",
  primaryMid: "#818CF8",
  accent: "#7C3AED",
  accentLight: "#F5F3FF",

  surface: "#FFFFFF",
  surfaceAlt: "#F8F9FC",
  border: "#E8EAF0",
  textPrimary: "#111827",
  textSecondary: "#6B7280",
  textTertiary: "#9CA3AF",

  quiz: "#0EA5E9",
  quizLight: "#E0F2FE",
  survey: "#059669",
  surveyLight: "#ECFDF5",
  external: "#F59E0B",
  externalLight: "#FFFBEB",
  internal: "#6366F1",
  internalLight: "#EEF2FF",
};

const campaignSchedule = {

  22: {
    title: "Sound.Mind.Connection",
    description: "  Join us for an insightful conversation with <strong> Dr. Shanthala Hegde </strong>, Professor, Clinical Neuropsychology Unit and Faculty-in-Charge, Music Cognition Lab, NIMHANS Bengaluru, as we explore the fascinating relationship between <strong>music and the brain</strong>. Discover how music influences cognition, emotions, memory, and mental well-being through the lens of neuroscience and research.",
    buttonText: "Watch Video",
    videoUrl: "https://www.youtube.com/embed/B0cuVl0sTPQ",
    type: "video",
  },
  23: {
    title: "Rejuvenate with Echo Sounds",
    buttonText: "Explore",
    url: "/rejuvenate-sounds",
    type: "internal",
  },
  24: {
    title: "Quiz 1 - Sound & Wellbeing Quiz",
    description: "How much do you know about the power of sound?",
    buttonText: "Take Quiz",
    url: "https://forms.gle/rSkxX9DqJ7pgRu3K8",
    type: "external",
  },
  25: {
    title: "Relax & Rewind with echo Soundscapes",
    buttonText: "Explore",
    url: "/echo-soundscapes",
    type: "internal",
  },
  26: {
    title: "Manage your Thoughts with echo Soundscapes",
    buttonText: "Explore",
    url: "/sound-meditation",
    type: "internal",
  },
  29: {
    title: "Quiz 2 - Music & Culture Quiz",
    description: "How Well Do You Know the Stories Behind the Music?",
    buttonText: "Take Quiz",
    url: "https://forms.gle/xogRqyjq3eWpdoKz5",
    type: "external",
  },
  30: {
    title: "Sleep Stories with echo Soundscapes",
    buttonText: "Explore",
    url: "/sleep-stories",
    type: "internal",
  },
};

const getActivityStyle = (buttonText = "", type = "internal") => {
  const lower = buttonText.toLowerCase();

  if (lower.includes("quiz")) {
    return {
      color: tokens.quiz,
      light: tokens.quizLight,
      icon: <Quiz fontSize="small" />,
      chipLabel: "Quiz",
      variant: "contained",
      sx: {
        bgcolor: tokens.quiz,
        "&:hover": { bgcolor: "#0284C7" },
      },
    };
  }
  if (lower.includes("survey") || lower.includes("watch")) {
    return {
      color: tokens.survey,
      light: tokens.surveyLight,
      icon: <AssignmentTurnedIn fontSize="small" />,
      chipLabel: "Survey",
      variant: "contained",
      sx: {
        bgcolor: tokens.survey,
        "&:hover": { bgcolor: "#047857" },
      },
    };
  }
  if (type === "external") {
    return {
      color: tokens.external,
      light: tokens.externalLight,
      icon: <OpenInNew fontSize="small" />,
      chipLabel: "External",
      variant: "outlined",
      sx: {
        color: tokens.external,
        borderColor: tokens.external,
        "&:hover": {
          bgcolor: tokens.externalLight,
          borderColor: tokens.external,
        },
      },
    };
  }

  return {
    color: tokens.internal,
    light: tokens.internalLight,
    icon: <Explore fontSize="small" />,
    variant: "outlined",
    sx: {
      color: "#000",
      borderColor: "#000",
      bgcolor: "#fff",
      "&:hover": {
        bgcolor: "#f5f5f5",
        borderColor: "#000",
      },
    },
  };
};

const Campaign = () => {
  return null;
  const navigate = useNavigate();

  const handleCampaignCTA = (eventName) => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    trackCTA(eventName, user);
  };

  // const today =
  // Number(localStorage.getItem("testDay")) ||
  // new Date().getDate();
  // const currentDate = new Date();

  // const isCampaignActive =
  //   currentDate.getFullYear() === 2026 &&
  //   currentDate.getMonth() === 5 &&
  //   currentDate.getDate() >= 22 &&
  //   currentDate.getDate() <= 30;

  const today =
    Number(localStorage.getItem("testDay")) ||
    new Date().getDate();

  // const isCampaignActive = today >= 22 && today <= 30;
  // if (!isCampaignActive) {
  //   return null;
  // }

  // const today = 23;
  const todayActivity = campaignSchedule[today];
  console.log("todayActivity:", todayActivity);
  const activityStyle = todayActivity
    ? getActivityStyle(todayActivity.buttonText, todayActivity.type)
    : null;



  const [openVideo, setOpenVideo] = useState(false);

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", px: { xs: 1, sm: 0 } }}>
      <Card
        elevation={0}
        sx={{
          borderRadius: "16px",
          border: `1px solid ${tokens.border}`,
          overflow: "hidden",
          transition: "box-shadow 0.2s ease",
          "&:hover": {
            boxShadow: "0 8px 32px rgba(79,70,229,0.10)",
          },
        }}
      >
        {/* ── Gradient accent strip ──────────────────────────────────── */}
        <Box sx={{ height: 4, background: "linear-gradient(90deg, #22c55e, #14b8a6, #8b5cf6)" }} />

        <CardContent sx={{ p: { xs: 2, sm: 2.5 }, "&:last-child": { pb: 2.5 } }}>

          {/* ── Header ──────────────────────────────────────────────────── */}
          <Stack direction="row" alignItems="flex-start" spacing={1.5} mb={2}>
            {/* <Avatar
              sx={{
                width: 48,
                height: 48,
                background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)",
                borderRadius: "14px",
                flexShrink: 0,
                boxShadow: "0 4px 12px rgba(20,184,166,0.3)",
              }}
            >
              <MusicNote sx={{ color: "#fff", fontSize: 22 }} />
            </Avatar> */}

            <Box flex={1} minWidth={0}>
              {/* Music Campaign badge */}
              <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, bgcolor: tokens.primaryLight, borderRadius: "20px", px: 1.25, py: 0.3, mb: 0.75 }}>
                <MusicNote sx={{ fontSize: 10, color: tokens.primary }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: tokens.primary, letterSpacing: "0.07em", textTransform: "uppercase", fontSize: "0.6rem" }}>
                  Music Campaign
                </Typography>
              </Box>

              {/* Title */}
              <Typography
                variant="h6"
                fontWeight={700}
                sx={{
                  background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: 1.2,
                  mb: 0.5,
                }}
              >
                Echoes Across Cultures
              </Typography>

              {/* Subtitle */}
              <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.82rem', lineHeight: 1.5 }}>
                Exploring the music that moves us, connects us, and reminds us who we are.
              </Typography>
            </Box>
          </Stack>

          <Divider sx={{ borderColor: tokens.border, mb: 2 }} />

          {/* ── Campaign description ─────────────────────────────────────── */}
          <Stack spacing={0.75} mb={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.25 }}>
              Music &amp; Me
            </Typography>
            <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.82rem', lineHeight: 1.6 }}>
             Discover your Musical Personality. Music means something different to everyone.
            </Typography>
            <Stack spacing={0.25} pl={0.5}>
              {[
                "Some of us listen to music to celebrate.",
                "Some use it to focus.",
                "Some turn to it when life gets difficult.",
              ].map((line) => (
                <Stack key={line} direction="row" alignItems="center" spacing={1}>
                  <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: tokens.primaryMid, flexShrink: 0 }} />
                  <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.82rem', lineHeight: 1.6 }}>
                    {line}
                  </Typography>
                </Stack>
              ))}
            </Stack>
            <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.82rem', lineHeight: 1.6 }}>
              Take this quick journey to help us understand your unique relationship with music.
            </Typography>
          </Stack>

          {/* ── Survey CTA ──────────────────────────────────────────────── */}
          <Button
            variant="contained"
            size="small"
            endIcon={<OpenInNew fontSize="small" />}
            onClick={() => {
              handleCampaignCTA("campaign_survey");
              window.open("https://forms.gle/CPJ76H5He3efqQnw9", "_blank");
            }}
            sx={{
              bgcolor: tokens.survey,
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "0.8125rem",
              textTransform: "none",
              px: 2,
              background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)",
              py: 0.75,
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#047857",
                boxShadow: "0 4px 12px rgba(5,150,105,0.25)",
              },
            }}
          >
            Open Survey
          </Button>

          {/* ── Today's activity (nested block) ─────────────────────────── */}
          {todayActivity && activityStyle && (
            <>
              <Divider sx={{ borderColor: tokens.border, mt: 2, mb: 1.5 }} />

              <Box
                sx={{
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)",
                  p: { xs: 2, sm: 2.5 },
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Decorative background blobs */}
                <Box sx={{ position: "absolute", width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,0.08)", top: -35, right: -25, pointerEvents: "none" }} />
                <Box sx={{ position: "absolute", width: 65, height: 65, borderRadius: "50%", background: "rgba(255,255,255,0.06)", bottom: 12, right: 36, pointerEvents: "none" }} />

                {/* Pill badge label */}
                <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, bgcolor: "rgba(255,255,255,0.18)", borderRadius: "20px", px: 1.5, py: 0.4, mb: 1.5 }}>
                  <TodayRounded sx={{ fontSize: 12, color: "#fff" }} />
                  <Typography variant="caption" sx={{ fontWeight: 700, color: "#fff", letterSpacing: "0.07em", textTransform: "uppercase", fontSize: "0.65rem" }}>
                    Today's Activity
                  </Typography>
                </Box>

                {/* Title */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    color: "#fff",
                    lineHeight: 1.3,
                    mb: 1,
                  }}
                >
                  {todayActivity.title}
                </Typography>

                {/* Description */}
                {todayActivity.description && (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.8rem",
                      color: "rgba(255,255,255,0.82)",
                      lineHeight: 1.55,
                      mb: 2,
                    }}
                    dangerouslySetInnerHTML={{ __html: todayActivity.description }}
                  />
                )}

                {/* CTA button */}
                <Button
                  size="small"
                  onClick={() => {
                    handleCampaignCTA("campaign_activity");
                    if (todayActivity.videoUrl) {
                      setOpenVideo(true);
                    } else if (todayActivity.type === "internal") {
                      navigate(todayActivity.url);
                    } else {
                      window.open(todayActivity.url, "_blank");
                    }
                  }}
                  sx={{
                    borderRadius: "20px",
                    fontWeight: 700,
                    fontSize: "0.8rem",
                    textTransform: "none",
                    px: 2.5,
                    py: 0.75,
                    background: "#fff",
                    color: "#0d9488",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                    border: "none",
                    "&:hover": {
                      background: "#f0fdfa",
                      boxShadow: "0 6px 18px rgba(0,0,0,0.22)",
                    },
                  }}
                >
                  {todayActivity.buttonText}
                </Button>
              </Box>
            </>
          )}
        </CardContent>
      </Card>
      <Dialog
        open={openVideo}
        onClose={() => setOpenVideo(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent
          sx={{
            p: 0,
            position: "relative",
            background: "#000",
          }}
        >
          <IconButton
            onClick={() => setOpenVideo(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
              bgcolor: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          <iframe
            width="100%"
            height="500"
            src={todayActivity?.videoUrl}
            title="Campaign Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Campaign;

